import {Component, OnInit, ViewChild} from '@angular/core';
import {RecaptchaComponent} from 'ng-recaptcha';
import {TfaLoginPayload, TokenPayload, UserService} from "../services/user.service";
import {ActivatedRoute, Router} from "@angular/router";
import {RoutingstateService} from "../services/routingstate.service";
import {NotificationsService} from "angular2-notifications";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {AssetsService} from "../services/assets.service";
import {AdminService} from "../services/admin.service";
import {Globals} from "../app-globals";
import {ExchangeService} from "../services/exchange.service";

@Component({
    selector: 'app-applogin',
    templateUrl: './applogin.component.html',
    styleUrls: ['./applogin.component.css']
})
export class ApploginComponent implements OnInit {
    hide: boolean = true;
    adminLogin: TokenPayload = {
        email: '',
        password: '',
        authflag: true,
        _csrf: null,
        captcha: ''
    };

    previousRoute: string;
    verificationstr = '';
    deviceVerificationSent = false;
    deviceVerificationMessage = '';
    tfaRequired = false;
    tfaCode = '';

    @ViewChild('captchaRef') captchaRef: RecaptchaComponent;

    constructor(private userService: UserService,
                private router: Router,
                private routingState: RoutingstateService,
                private  notifSer: NotificationsService,
                private spinnerService: Ng4LoadingSpinnerService,
                private assetsService: AssetsService,
                private adminService: AdminService,
                private actroute: ActivatedRoute,
                private exchageService: ExchangeService,
                private global: Globals) {
    }
    showPassword = false;

    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    }
    ngOnInit() {
        if (this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/home');
        } else {
            this.verificationstr = this.actroute.snapshot.paramMap.get('str');
            if (this.verificationstr) {
                if (this.router.url.startsWith('/adminverifydevice')) {
                    this.verifyDevice(this.verificationstr);
                } else {
                    this.verifyemail(this.verificationstr);
                }
            }
            this.csrf();
            this.previousRoute = this.routingState.getPreviousUrl();
            if (this.userService.isLoggedIn()) {
                this.router.navigateByUrl(this.previousRoute);
            }
        }
    }
    verifyemail(str) {
        this.exchageService.getEmailVerified(str).subscribe((result) => {
            this.notifSer.success(
                'Success',
                result.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }

            )
            this.router.navigateByUrl('/index');
        }, (err) => {
            // if (err.error.message == 'Link Expired') {
            //     this.expiredlink = true;
            // }
            this.notifSer.error(
                'Error',
                err.error.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }

            )
        })
    }
    verifyDevice(str) {
        // Client ip is attached to every request by ClientIpInterceptor (see
        // interceptors/client-ip.interceptor.ts) - no need to fetch/pass it here.
        this.userService.verifyAdminDevice(str).subscribe((result) => {
            this.notifSer.success(
                'Success',
                result.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }
            )
            this.router.navigateByUrl('/index');
        }, (err) => {
            this.notifSer.error(
                'Error',
                err.error.message,
                {
                    timeOut: 5000,
                    showProgressBar: true,
                    pauseOnHover: true,
                    clickToClose: true,
                    maxLength: 50
                }
            )
            this.router.navigateByUrl('/index');
        })
    }
    login() {
        this.spinnerService.show();
        this.deviceVerificationSent = false;
        // Client ip is attached to every request by ClientIpInterceptor (see
        // interceptors/client-ip.interceptor.ts) - no need to fetch/pass it here.
        this.userService.csrf().subscribe((response) => {
            // console.log(response)
            this.adminLogin._csrf = response._csrf;
            this.userService.login(this.adminLogin).subscribe((response) => {
                if (response.token) {
                    this.getMenu();
                    this.router.navigateByUrl('/home');
                } else if (response.tfaRequired) {
                    this.tfaRequired = true;
                    this.spinnerService.hide();
                    return;
                } else if (response.newDevice) {
                    // A toast alone is easy to miss (it auto-dismisses); this is the
                    // only unauthenticated action here, so show a persistent on-page
                    // confirmation too rather than relying on the toast being seen.
                    this.deviceVerificationSent = true;
                    this.deviceVerificationMessage = response.message;
                    this.notifSer.info(
                        'Verify Device',
                        response.message,
                        {
                            timeOut: 5000,
                            showProgressBar: true,
                            pauseOnHover: true,
                            clickToClose: true,
                            maxLength: 100
                        }
                    )
                }
                this.spinnerService.hide();
            }, (err) => {
                if (err.status == 401) {
                    this.notifSer.error(
                        'Error',
                        err.error.message,
                        {
                            timeOut: 3000,
                            showProgressBar: true,
                            pauseOnHover: false,
                            clickToClose: true,
                            maxLength: 50
                        }
                        )
                    } else {
                        this.notifSer.error(
                            'Error',
                            err.error.message,
                            {
                                timeOut: 3000,
                                showProgressBar: true,
                                pauseOnHover: false,
                                clickToClose: true,
                                maxLength: 50
                            }
                            )
                        }
                        this.resetCaptcha();
                        this.spinnerService.hide();

                    });
                }, (err) => {
                    this.notifSer.error(
                        'Error CSRF',
                        err.error.message,
                        {
                            timeOut: 3000,
                            showProgressBar: true,
                            pauseOnHover: false,
                            clickToClose: true,
                            maxLength: 50
                        }
                    )
                });
    }

    submitTfaCode() {
        this.spinnerService.show();
        this.userService.csrf().subscribe((response) => {
            const payload: TfaLoginPayload = {
                email: this.adminLogin.email,
                password: this.adminLogin.password,
                code: this.tfaCode,
                _csrf: response._csrf,
                captcha: this.adminLogin.captcha
            };
            this.userService.tfaLogin(payload).subscribe((tfaResponse) => {
                this.spinnerService.hide();
                if (tfaResponse.token) {
                    this.getMenu();
                    this.router.navigateByUrl('/home');
                }
                else if (tfaResponse.newDevice) {
                    // A toast alone is easy to miss (it auto-dismisses); this is the
                    // only unauthenticated action here, so show a persistent on-page
                    // confirmation too rather than relying on the toast being seen.
                    this.deviceVerificationSent = true;
                    this.deviceVerificationMessage = tfaResponse.message;
                    this.notifSer.info(
                        'Verify Device',
                        tfaResponse.message,
                        {
                            timeOut: 5000,
                            showProgressBar: true,
                            pauseOnHover: true,
                            clickToClose: true,
                            maxLength: 100
                        }
                    )
                }
            }, (err) => {
                this.spinnerService.hide();
                this.resetCaptcha();
                this.notifSer.error(
                    'Error',
                    err.error.message,
                    {
                        timeOut: 3000,
                        showProgressBar: true,
                        pauseOnHover: false,
                        clickToClose: true,
                        maxLength: 50
                    }
                )
            });
        }, (err) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error CSRF',
                err.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        });
    }

    backToLogin() {
        this.tfaRequired = false;
        this.tfaCode = '';
        this.adminLogin.password = '';
        this.resetCaptcha();
        this.csrf();
    }

    getMenu() {
        this.adminService.getAdminPanelMenus().subscribe((success) => {
            var menulist = success.menu;
            if(menulist !== undefined)
                localStorage.setItem('permission', menulist[0].permission);
        }, (error) => {

        })
    }

    csrf() {
        this.userService.csrf().subscribe((response) => {
            // console.log(response)
            this.adminLogin._csrf = response._csrf;
        }, (err) => {
            this.notifSer.error(
                'Error CSRF',
                err.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        });
    }
    forgotpassword(){
        console.log('password');
    this.router.navigate(['forgot-password']);

    }

    resetCaptcha() {
        this.adminLogin.captcha = '';
        if (this.captchaRef) {
            this.captchaRef.reset();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/applogin/applogin.component.ts